import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
import { PROGRAM_FEATURES } from ".";
export function assertPointsBucketFeatures(features) {
    if (!Array.isArray(features)) {
        throw new Error("PointsBucket.features must be an array");
    }
    for (const feature of features) {
        if (!PROGRAM_FEATURES.includes(feature)) {
            throw new Error(`PointsBucket.features must only contain valid features: ${PROGRAM_FEATURES.join(", ")}`);
        }
    }
}
export const assertPointsBucket = (data, mode = "load") => {
    if (!data || typeof data !== "object") {
        throw new Error("PointsBucket must be an object");
    }
    const pointsBucket = data;
    // Required fields based on mode
    const requiredFields = mode === "save"
        ? ["features", "points"]
        : ["id", "features", "points", "createdAt", "modifiedAt"];
    for (const field of requiredFields) {
        if (!(field in pointsBucket)) {
            throw new Error(`PointsBucket is missing required field: ${field}`);
        }
    }
    // Type checks
    if (mode === "load" && typeof pointsBucket.id !== "string") {
        throw new Error("PointsBucket.id must be a string");
    }
    if (typeof pointsBucket.points !== "number") {
        throw new Error("PointsBucket.points must be a number");
    }
    // Validate features
    assertPointsBucketFeatures(pointsBucket.features);
    return true;
};
export const createPointsBucket = (data) => {
    if (!assertPointsBucket(data, "save")) {
        throw new Error("PointsBucket.save failed");
    }
    return data;
};
export const createPointsBucketConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(pointsBucket) {
        if (!assertPointsBucket(pointsBucket, "save")) {
            throw new Error("PointsBucket.save failed");
        }
        const { id, ...pointsBucketWithoutId } = pointsBucket;
        const data = {
            ...pointsBucketWithoutId,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(pointsBucket.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(pointsBucket.modifiedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const pointsBucket = {
            ...data,
            id: snapshot.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
        };
        if (!assertPointsBucket(pointsBucket, "load")) {
            throw new Error("PointsBucket.load failed");
        }
        return pointsBucket;
    },
});
//# sourceMappingURL=PointsBucket.js.map